import * as React from 'react';

const EyeSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="eye_svg__eds-icon--eye_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="eye_svg__eds-icon--eye_base"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M11.9 6.5C6.4 6.5 2 12.7 2 12.7s4.4 6.2 9.9 6.2 9.9-6.2 9.9-6.2-4.4-6.2-9.9-6.2zm0 11.3c-3.9 0-7.4-3.6-8.6-5.1 1.2-1.5 4.7-5.1 8.6-5.1 3.9 0 7.4 3.6 8.6 5.1-1.2 1.5-4.7 5.1-8.6 5.1"
        />
        <path
            id="eye_svg__eds-icon--eye_circle"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M11.9 9.1c-1.9 0-3.5 1.6-3.5 3.6s1.5 3.6 3.5 3.6 3.5-1.6 3.5-3.6-1.6-3.6-3.5-3.6zm0 6.1c-1.4 0-2.5-1.1-2.5-2.6 0-1.4 1.1-2.6 2.5-2.6s2.5 1.1 2.5 2.6-1.1 2.6-2.5 2.6z"
        />
    </svg>
);

EyeSvg.displayName = 'EyeSvg';
export default EyeSvg;
